import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { API, brl } from "../lib/api";

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [st, setSt] = useState(cancelled ? { status: "cancelled" } : null);

  useEffect(() => {
    if (cancelled || !sid) return undefined;
    let n = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sid}`);
        setSt(data);
        if (data.status === "pending" && n++ < 10) timer = setTimeout(poll, 2000);
      } catch {
        setSt({ status: "error" });
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, cancelled]);

  const paid = st?.status === "paid";
  const bad = ["cancelled", "error", "expired", "failed"].includes(st?.status);
  const Icon = paid ? CheckCircle2 : bad ? XCircle : Clock;
  return (
    <div className="auth-screen" data-testid="payment-result-page">
      <div className="card w-full max-w-md text-center fade-up">
        <Icon size={48} className={`mx-auto ${paid ? "text-emerald-400" : bad ? "text-rose-400" : "text-amber-400"}`} />
        <h1 className="mt-4 font-heading text-3xl font-extrabold" data-testid="payment-result-title">
          {paid ? "Pagamento confirmado" : bad ? "Pagamento não concluído" : "Confirmando pagamento..."}
        </h1>
        {st?.amount ? <p className="mt-2 font-mono text-xl text-slate-200">{brl(st.amount)}</p> : null}
        <p className="mt-3 text-sm text-slate-400">{paid ? "Obrigado! Você já pode fechar esta página." : bad ? "Nenhuma cobrança foi feita." : "Aguarde alguns segundos."}</p>
      </div>
    </div>
  );
}
